import React, { useState } from 'react'
import Settings from './Settings'
import { useDispatch, useSelector } from 'react-redux'
import { resetEconomicSliceState, selectCreateTask, selectTaskStatus, setCreateTask } from 'store/economicSlice'
import Results from './Results'
import classNames from 'classnames'
import Resizable from 'components/Resizeable/resizable'
import Handle from 'components/Handle/handle'
import Button from 'components/Button'
import RedoIcon from 'images/RedoIcon'
import DownloadIcon from 'images/DownloadIcon'
import useGetDumps from './hooks/useGetDumps'

const EconomicCalc: React.FC = () => {
  const dispatch = useDispatch()
  const createTask = useSelector(selectCreateTask)
  const taskStatus = useSelector(selectTaskStatus)
  const [requestDump, setRequestDump] = useState<boolean>(false)
  const [showSettings, setShowSettings] = React.useState<boolean>()

  useGetDumps({ requestData: requestDump, setRequestData: setRequestDump })

  React.useEffect(() => {
    if (['Рассчитан', 'Ошибка', 'Отменен'].includes(taskStatus!)) {
      setShowSettings(false)
    }
  }, [taskStatus])

  const calculate = () => {
    dispatch(resetEconomicSliceState())
    dispatch(setCreateTask(true))
  }

  return (
    <Resizable className={'hydraulic-calc__container'} right handleElement={<Handle />}>
      {(!['Рассчитан', 'Ошибка'].includes(taskStatus!) || showSettings) && (
        <>
          <div className={classNames('hydraulic-calc__content')}>
            <Settings />
          </div>
          <div className={'calc__bottom-panel'}>
            {showSettings && (
              <Button
                className={'hydraulic-settings__button'}
                mode={'secondary'}
                onClick={() => setShowSettings(false)}
              >
                Отменить
              </Button>
            )}
            <Button className={'hydraulic-settings__button'} onClick={calculate} disabled={createTask}>
              Рассчитать
            </Button>
          </div>
        </>
      )}
      {['Рассчитан', 'Ошибка'].includes(taskStatus!) && !showSettings && (
        <>
          <div className={classNames('hydraulic-calc__content')}>
            <Results />
          </div>
          <div className={'calc__bottom-panel'}>
            <Button mode={'secondary'} onClick={() => setRequestDump(true)}>
              <DownloadIcon />
              Лог-файл
            </Button>
            <Button onClick={() => setShowSettings(true)}>
              <RedoIcon className={'redo-icn'} />
              Пересчитать с новыми параметрами
            </Button>
          </div>
        </>
      )}
    </Resizable>
  )
}

export default EconomicCalc
